export const STAGE_MAP = {
  INTAKE: { 
    pct: 0, 
    label: "Intake", 
    helper: "Initial intake & setup" 
  },
  COPY_DRAFT: { 
    pct: 25, 
    label: "Copy Draft", 
    helper: "Content creation phase" 
  },
  DESIGN: { 
    pct: 40, 
    label: "Design Mock", 
    helper: "Visual mockups in progress" 
  },
  DEV: { 
    pct: 60, 
    label: "Development", 
    helper: "Build and integrations" 
  },
  QA: { 
    pct: 80, 
    label: "QA", 
    helper: "Review & revisions" 
  },
  LAUNCHED: { 
    pct: 100, 
    label: "Launched", 
    helper: "Project is live" 
  }
};

export const STATUS_OPTIONS = {
  'New': 'Lead accepted; not started',
  'Active': 'Work in progress',
  'On Hold': 'Paused by internal reasons',
  'Awaiting Client': 'Blocked pending client action',
  'Completed': 'Project delivered',
  'Cancelled': 'Project closed without delivery'
};

export const getStageFromPercent = (pct) => {
  const stages = Object.entries(STAGE_MAP);
  for (let i = stages.length - 1; i >= 0; i--) {
    if (pct >= stages[i][1].pct) {
      return stages[i][0];
    }
  }
  return 'INTAKE';
};
